import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "../../alert.service";
import { StorageService } from "../../storage.service";
import { ReportTypes } from "../../../reports/models/reports";
import { PerformanceTableResponse } from "../../../_models/dashboard";

@Injectable({
  providedIn: "root",
})
export class SubscriptionFrequencyService extends DashboardService {
  route = "subscription_dashboard/performance_by_frequency";
  protected reportType = ReportTypes.SUBSCRIPTION_RETENTION;
  protected data: BehaviorSubject<PerformanceTableResponse> = new BehaviorSubject<PerformanceTableResponse>(undefined);

  constructor(
    protected http: HttpClient,
    protected alertService: AlertService,
    protected storageService: StorageService
  ) {
    super(http, alertService, storageService);
  }

}
